export function getClasses(classes: string | (string | undefined | null | false)[]): string {
  const all = typeof classes === `string` ? [classes,] : classes.filter(Boolean) as string[];
  return all.join(` `).trim();
};
